import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";
import useDateInput, { DateInput } from "@/components/form/date-input";
import useSelectInput, { SelectInput } from "@/components/form/select-input";

const S13 = (props) => {
    const complaintRadio = useRadioInput({
        name: "sale[claim][made]", label: "Har du reklamert til selger?",
        options: {
            data: [
                { label: "Ja", value: "TRUE" },
                { label: "Nei", value: "FALSE" },
            ],
        },
        tooltip: "Kjøper har plikt til å reklamere til selger innen \"rimelig tid\" etter at kjøper oppdaget eller burde ha oppdaget feilen. Som regel anses 2-3 måneder fra feilen ble eller burde blitt oppdaget som \"rimelig tid\".",
        ...props,
    })

    const complaintSpeedRadio = useRadioInput({
        name: "sale[claim][wait_time]", label: "Hvor raskt reklamerte du til selger etter du oppdaget problemet?",
        options: {
            data: [
                { label: "Null til fire uker etter jeg oppdaget problemet", value: "u0-4" },
                { label: "Én til tre måneder etter jeg oppdaget problemet", value: "m1-3" },
                { label: "Mer enn tre måneder etter jeg oppdaget problemet", value: "m3+" },
                { label: "Annet/ikke relevant", value: "OTHER" },
            ],
        },
        ...props,
    })

    // const claimDate = useDateInput({
    //     name: "sale[claim][date]", label: "Når reklamerte du?",
    //     ...props,
    // })

    const answerReceived = useSelectInput({
        name: "sale[claim][answer]", label: "Hva svarte selger?",
        options: {
            includeBlank: "Velg ett svar",
            data: [
                { label: "Selger avviste/var uenig", value: "REJECTED" },
                { label: "Jeg fikk et tilbud", value: "DISCOUNT" },
                { label: "Ikke fått svar", value: "NONE" },
            ],
        },
        ...props,
    })

    const answerDate = useDateInput({
        name: "sale[claim][answer_date]", label: "Når fikk du dette svaret fra selger?",
        ...props,
        disabled: props?.disabled || answerReceived.is("NONE") || answerReceived.isBlank(),
    })

    return (
        <Wrapper {...props} header="Fortell oss om reklamasjonen">
            <RadioInput {...complaintRadio.props}/>
            { complaintRadio.value === "TRUE" &&
            <>
                <RadioInput {...complaintSpeedRadio.props} className="mt-7"/>

                {/*<DateInput {...claimDate.props} className="mt-7"/>*/}
                <div className="group gg-3 mt-7">
                    <SelectInput {...answerReceived.props}/>
                    <DateInput {...answerDate.props} className={ answerDate.props?.input?.disabled ? "hidden--partial" : "" }/>
                </div>
            </>
            }
        </Wrapper>
    );
};

export default S13;
